import type { MotionProps } from 'framer-motion';

// easeOutCubic — matches the Stats module reveal.
const EASE = [0.33, 1, 0.68, 1] as const;

/**
 * Per-block scroll reveal for hero modules ("Website 2026"). Unlike the
 * CSS `is-hidden` section fade, each block reveals independently the first
 * time it enters the viewport; `order` staggers blocks that enter together
 * (e.g. on the initial reveal). The section background is never animated.
 */
export function heroReveal(order: number): MotionProps {
  return {
    initial: 'hidden',
    whileInView: 'show',
    viewport: { once: true, margin: '-80px 0px' },
    variants: {
      hidden: { opacity: 0, y: 32 },
      show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay: order * 0.15, ease: EASE },
      },
    },
  };
}
